import { TargetingValues } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';
import { defaultTargetingParameters } from '@provider-portal/common/services/targetingDefaults';

import { NetworkRequestState } from '@bolteu/redux-session';

import { GlobalAppState } from 'rdx/state';

export const selectIsTargetingParametersRequestFinished = (state: GlobalAppState) => {
  return (
    state.targetingParameters.fetchingState === NetworkRequestState.success ||
    state.targetingParameters.fetchingState === NetworkRequestState.failure ||
    (state.targetingParameters.fetchingState === NetworkRequestState.waiting &&
      state.targetingParameters.isDoingSafeRefresh &&
      !!state.targetingParameters.parameters)
  );
};

export const selectTargetingParameters = (state: GlobalAppState): TargetingValues => {
  return state.targetingParameters.parameters ?? defaultTargetingParameters;
};
